import {
  themeActions,
  position_name,
  PHOTOS_STATUS,
  defaultCapturePhotos,
  captureFlow,
} from './config';
import { map as arrayMap } from 'lodash';

export const changProgresStatus = (view, type, array, cb) => {
  let arrTemp = [...array];
  const result = arrTemp.map((item) => {
    if (item.position === view) {
      item.status = type;
    }
    return item;
  });
  cb(result);
};

export const getDataFlow = (type, customFlow = []) => {
  let initFlow = [];
  switch (type) {
    case themeActions.PAVE_PLATE_LEFT:
      initFlow = captureFlow.plateLeft;
      break;
    case themeActions.PAVE_PLATE_RIGHT:
      initFlow = captureFlow.plateRight;
      break;
    case themeActions.PAVE_REAR_TIRE:
      initFlow = captureFlow.rearTire;
      break;
    case 'CUSTOM':
      initFlow = customFlow;
      break;
    default:
      initFlow = customFlow.length > 0 ? customFlow : captureFlow.default;
      break;
  }
  return arrayMap(initFlow, (code, pos) => {
    return { ...defaultCapturePhotos[code], state: pos + 1 };
  });
};

export const mapDataStatus = (photos, vinData, arr, options = {}) => {
  let { missing } = photos;  
  if (!missing) missing = [];

  if (missing.length === 0) {
    const dataTemp = arr.map((item) => {
      let found = item;
      if (found) {
        found.status = PHOTOS_STATUS.FINISH;
        found.reason = PHOTOS_STATUS.FINISH;
        found.passed = true;
      }
      return found;
    });
    return dataTemp;
  }
  
  const missingArr = arr.map((item) => {
    const data = missing.map((code) => {
      if (parseInt(item.photoCodeUpload) === parseInt(code)) {
        item.status = PHOTOS_STATUS.MISSING;
        item.passed = true;
      }
      if (parseInt(missing[0]) !== 1 && item.photoCodeUpload === 1) {
        item.status = PHOTOS_STATUS.FINISH;
        item.passed = true;
        item.reason = PHOTOS_STATUS.FINISH;
      }
      return item;
    });
    return data[0] || item;
  });
    
  return missingArr;
};

export const skipCaptureProcess = (skips, origins) => {
  return origins.map((el) => {
    const found = skips.find(
      (item) => item === el.position && item !== position_name['ODOMETER']
    );
    if (found) {
      el.status = PHOTOS_STATUS.FINISH;
      el.reason = PHOTOS_STATUS.FINISH;
    }
    return el;
  });
};
